import { b as _extends, a as _objectSpread } from './chunk-fb907809.js';
import React__default, { createElement, Component } from 'react';
import PropTypes__default, { func, string, oneOfType, arrayOf, bool, number, oneOf, object, objectOf, node } from 'prop-types';
import { Container } from 'constate';

var initialState = {
  visible: false
};
var show = function show() {
  return function () {
    return {
      visible: true
    };
  };
};
var hide = function hide() {
  return function () {
    return {
      visible: false
    };
  };
};
var toggle = function toggle() {
  return function (state) {
    return {
      visible: !state.visible
    };
  };
};
var actions = {
  show: show,
  hide: hide,
  toggle: toggle
};

var HiddenContainer = function HiddenContainer(props) {
  return createElement(Container, _extends({}, props, {
    initialState: _objectSpread({}, initialState, props.initialState),
    actions: actions
  }));
}; // @ts-ignore


HiddenContainer.propTypes = {
  initialState: object,
  actions: objectOf(func)
};

export { HiddenContainer as a };
